// extracted by mini-css-extract-plugin
module.exports = {"root":"I7zg1c_"};